// Shared submission handling for the private-events and consulting forms.
document.querySelectorAll('form[data-contact-form]').forEach(function(form) {
  var submitting = false
  var fallback = "We could not send your inquiry. Please try again or email support@onyxcoffeelab.com."

  form.addEventListener('submit', async function(event) {
    event.preventDefault()
    if (submitting) return

    var fields = Array.from(new FormData(form), function(field) {
      return { name: field[0], value: field[1] }
    })
    var button = form.querySelector('[type="submit"]')
    var container = form.closest('.consulting-form')
    var error_message = fallback

    submitting = true
    button.disabled = true
    form.setAttribute('aria-busy', 'true')
    container.classList.remove('broken')

    try {
      var response = await fetch('https://product.onyxcontent.com/contact.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ form: form.dataset.contactForm, fields: fields })
      })
      var result = await response.json()
      if (!response.ok || result.success !== true) {
        if (typeof result.message === 'string') error_message = result.message
        throw new Error('Submission failed')
      }
      container.classList.add('success')
    } catch (error) {
      container.classList.add('broken')
      alert(error_message)
    } finally {
      submitting = false
      button.disabled = false
      form.removeAttribute('aria-busy')
    }
  })
})
